import { FETCH_UPTIME_REPORT } from 'actions/uptimeReport';

const initialState = {
    isLoading: false,
    uptimeReportData: [],
}

const uptimeReportReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_UPTIME_REPORT.REQUEST: {
            return { ...state, isLoading: true };
        }
        case FETCH_UPTIME_REPORT.SUCCESS: {
            return {
                ...state,
                isLoading: false,
                uptimeReportData: payload,
            };
        }
        case FETCH_UPTIME_REPORT.FAIL: {
            return { ...state, isLoading: false };
        }
        default:
            return { ...state };
    }
}

export default uptimeReportReducer;